var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBeatFrequencySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#49238b",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.103,224.804H325.03L291.139,55.521c-0.847-4.233-4.603-7.149-8.943-7.005c-4.314,0.14-7.893,3.421-8.463,7.699 l-46.504,348.801l-59.726-261.292c-0.902-3.947-4.374-6.769-8.422-6.853c-3.962-0.04-7.635,2.599-8.699,6.506l-45.879,168.222 l-34.469-89.792c-1.311-3.408-4.586-5.831-8.239-5.831H8.828c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828 h46.903l41.961,109.273c1.37,3.562,4.876,5.914,8.684,5.735c3.811-0.193,7.068-2.769,8.071-6.451l43.695-160.192l62.769,274.627 c0.921,4.029,4.504,6.866,8.601,6.866c0.137,0,0.274-0.001,0.41-0.008c4.266-0.195,7.779-3.416,8.344-7.649l45.958-344.684 l24.912,124.387c0.825,4.126,4.448,6.924,8.656,6.924h35.31c4.875,0,8.828-3.953,8.828-8.828 C361.931,228.756,357.978,224.804,353.103,224.804z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M441.379,224.804h-44.138c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828h44.138 c4.875,0,8.828-3.953,8.828-8.828C450.207,228.756,446.254,224.804,441.379,224.804z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.172,224.804H476.69c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828h26.483 c4.875,0,8.828-3.953,8.828-8.828C512,228.756,508.047,224.804,503.172,224.804z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBeatFrequencySvgrepoCom);
export default __webpack_public_path__ + "static/media/heart-beat-frequency-svgrepo-com.3f65065559538c4056ba379676253c98.svg";
export { ForwardRef as ReactComponent };